const cities = [
  { name: "Franklin", zips: "37064, 37067, 37069" },
  { name: "Brentwood", zips: "37027" },
  { name: "Spring Hill", zips: "37174" },
  { name: "Thompson's Station", zips: "37179" },
  { name: "Nolensville", zips: "37135" },
  { name: "Fairview", zips: "37062" },
  { name: "College Grove", zips: "37046" },
  { name: "Arrington", zips: "37014" },
];

const benefits = [
  {
    icon: "ri-computer-line",
    title: "Start 100% Online",
    desc: "No office visit required to begin. Complete your order from your Cool Springs office, your Brentwood home, or anywhere in Williamson County.",
  },
  {
    icon: "ri-truck-line",
    title: "Ship Your Documents",
    desc: "Use overnight shipping to send your documents directly to us — multiple FedEx and UPS locations throughout Franklin make this easy.",
  },
  {
    icon: "ri-shield-check-line",
    title: "Expert Document Review",
    desc: "Every application is reviewed by our team before submission to reduce errors and prevent costly delays on your corporate or family travel.",
  },
  {
    icon: "ri-calendar-check-line",
    title: "Reserved Agency Access",
    desc: "We hold reserved submission slots at the regional passport agency — you don't race for a public appointment that may never open.",
  },
];

export default function FranklinTNLocalAreaSection() {
  return (
    <section id="service-area" className="bg-white py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Service Area</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Serving Franklin &amp; All of Williamson County
          </h2>
        </div>

        <div className="max-w-4xl mx-auto mb-16">
          <div className="bg-[#F7F8FA] rounded-lg p-8 md:p-10 border border-gray-200">
            <p className="text-gray-600 text-base leading-[1.8] mb-5">
              Franklin, Tennessee sits at the heart of Williamson County — the wealthiest county in Tennessee and consistently ranked among the top 10 wealthiest counties in the entire United States. This is not a minor distinction when it comes to passport demand. Affluent households travel internationally at dramatically higher rates than the national average, and Franklin's explosive population growth over the past decade means thousands of new residents who may not yet have a passport infrastructure established in their new home state.
            </p>
            <p className="text-gray-600 text-base leading-[1.8] mb-5">
              The Cool Springs corporate corridor is one of the most economically significant commercial zones in Middle Tennessee. Companies like MARS Petcare, Tractor Supply Co., Dollar General (headquartered just up I-65 in Goodlettsville), Community Health Systems, and countless healthcare and technology firms maintain substantial operations here. Their executives travel internationally for board meetings, supplier visits, acquisition due diligence, and international conferences — often on timelines that standard passport processing simply cannot accommodate.
            </p>
            <p className="text-gray-600 text-base leading-[1.8] mb-5">
              The Nashville Passport Agency at 801 Broadway serves the entire Middle Tennessee region — but appointment availability is notoriously competitive, and self-service applicants must meet strict eligibility requirements. Franklin residents who need a passport in less than two weeks often feel the same pinch as travelers two hours from the nearest agency: the appointment system isn't designed for the volume of demand Williamson County generates. Fast Passport Center fills that gap with reserved courier access — no public appointment needed, no showing up at 5am hoping to get seen.
            </p>
            <p className="text-gray-600 text-base leading-[1.8]">
              Beyond the business travel corridor, Franklin's family demographics create massive leisure passport demand. Spring Hill and Thompson's Station families book Caribbean cruises and Mexican resort vacations. Nolensville and College Grove residents plan European summer itineraries. With Nashville International Airport (BNA) just 20 miles north and a highly mobile, dual-income household base, international travel from Williamson County is not an occasional event — it is a lifestyle pattern. When a passport expires at an inconvenient time or a family realizes their child has never had one, they need a solution that moves as fast as they do.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
          <div>
            <div className="bg-[#1A365D] rounded-lg p-7 mb-8 text-white">
              <div className="flex items-center gap-3 mb-5">
                <div className="w-11 h-11 flex items-center justify-center rounded-full bg-[#F6C344] flex-shrink-0">
                  <i className="ri-passport-line text-[#1A365D] text-xl"></i>
                </div>
                <div>
                  <p className="font-bold text-base">Fast Passport Center — Franklin, TN</p>
                  <p className="text-white/60 text-xs mt-0.5">Serving all of Williamson County</p>
                </div>
              </div>
              <p className="text-white/70 text-sm mb-1">
                <i className="ri-map-pin-line text-[#F6C344] mr-1.5"></i>
                Serving Franklin, Brentwood, Spring Hill &amp; all of Williamson County
              </p>
              <p className="text-white/50 text-xs mb-5 ml-5">Documents ship overnight from any FedEx or UPS location in the Franklin area</p>
              <div className="border-t border-white/10 pt-5">
                <p className="text-white/80 text-sm leading-relaxed mb-4">
                  After signing up online, choose what works best for you: <strong className="text-white">ship with our prepaid label</strong> from any UPS/FedEx location in the Franklin area, or <strong className="text-white">schedule a drop-off</strong> at a courier location near your Cool Springs office or Brentwood home. Most clients ship overnight — no office visit required.
                </p>
                <a
                  href="https://fastpassportcenter.com/checkout/"
                  className="inline-flex items-center gap-2 bg-[#F6C344] hover:bg-[#e5b430] text-[#1A365D] font-bold text-sm px-5 py-2.5 rounded-md transition-all whitespace-nowrap"
                >
                  Start My Passport <i className="ri-arrow-right-line"></i>
                </a>
              </div>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {benefits.map((b, i) => (
                <div key={i} className="bg-[#F7F8FA] rounded-lg p-5 border border-gray-200">
                  <div className="w-9 h-9 flex items-center justify-center rounded-full bg-[#F6C344]/15 mb-3">
                    <i className={`${b.icon} text-[#1A365D] text-base`}></i>
                  </div>
                  <p className="font-bold text-[#1A365D] text-sm mb-1">{b.title}</p>
                  <p className="text-gray-500 text-xs leading-relaxed">{b.desc}</p>
                </div>
              ))}
            </div>
          </div>

          <div>
            <div className="bg-[#F7F8FA] rounded-lg p-7 mb-6 border border-gray-200">
              <h3 className="font-bold text-[#1A365D] text-sm uppercase tracking-wide mb-5">
                <i className="ri-map-pin-2-line text-[#F6C344] mr-2"></i>
                Williamson County Communities We Serve
              </h3>
              <div className="space-y-1.5">
                {cities.map((city, i) => (
                  <div
                    key={i}
                    className="flex items-center justify-between py-2.5 px-3 bg-white rounded-md"
                  >
                    <div className="flex items-center gap-2.5">
                      <i className="ri-checkbox-circle-fill text-[#F6C344] text-sm"></i>
                      <span className="text-[#1A365D] font-medium text-sm">{city.name}</span>
                    </div>
                    {city.zips && (
                      <span className="text-gray-400 text-xs font-mono hidden sm:inline">{city.zips}</span>
                    )}
                  </div>
                ))}
              </div>
              <p className="text-gray-500 text-xs mt-4 leading-relaxed">
                Anywhere in Williamson County — start online, ship overnight from the Franklin or Brentwood area, and we handle the rest. No need to scramble for a Nashville passport agency appointment.
              </p>
              <div className="mt-4 pt-4 border-t border-gray-100">
                <p className="text-gray-400 text-xs font-semibold uppercase tracking-wider mb-3">Nearby Cities We Serve</p>
                <div className="flex flex-wrap gap-2">
                  {[
                    { name: "Nashville", href: "/cities/nashville" },
                    { name: "Murfreesboro", href: "/cities/murfreesboro" },
                    { name: "Clarksville", href: "/cities/clarksville" },
                    { name: "Knoxville", href: "/cities/knoxville" },
                    { name: "Chattanooga", href: "/cities/chattanooga" },
                    { name: "All TN Cities", href: "/states/tennessee" },
                  ].map((link) => (
                    <a
                      key={link.href}
                      href={link.href}
                      className="inline-flex items-center gap-1 text-xs text-[#1A365D] hover:text-[#F6C344] font-medium transition-colors bg-white border border-gray-200 hover:border-[#F6C344] rounded-full px-3 py-1.5 whitespace-nowrap"
                    >
                      {link.name} <i className="ri-arrow-right-line text-[10px]"></i>
                    </a>
                  ))}
                </div>
              </div>
            </div>

            <div className="bg-[#1A365D] rounded-lg p-5">
              <p className="text-white/50 text-xs uppercase tracking-widest font-semibold mb-4">Why Williamson County Travelers Choose Fast Passport Center</p>
              <div className="grid grid-cols-2 gap-3">
                {[
                  { icon: "ri-government-line", value: "Registered Courier", label: "U.S. Department of State" },
                  { icon: "ri-award-line", value: "A+ Rating", label: "Better Business Bureau" },
                  { icon: "ri-calendar-check-line", value: "20+ Years", label: "Serving Travelers Nationwide" },
                  { icon: "ri-customer-service-2-line", value: "Real Humans", label: "Live Support — Not a Bot" },
                ].map((item, i) => (
                  <a
                    key={i}
                    href="https://fastpassportcenter.com"
                    className="flex items-center gap-2.5 bg-white/5 hover:bg-white/10 rounded-md px-3 py-2.5 transition-colors cursor-pointer"
                  >
                    <div className="w-8 h-8 flex items-center justify-center rounded-full bg-[#F6C344]/15 flex-shrink-0">
                      <i className={`${item.icon} text-sm text-[#F6C344]`}></i>
                    </div>
                    <div className="text-left">
                      <span className="text-white text-xs font-bold block leading-tight">{item.value}</span>
                      <span className="text-white/50 text-xs leading-tight block">{item.label}</span>
                    </div>
                  </a>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}